import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=5a8a0bc4&scoped=true&"
import script from "./Viewer.vue?vue&type=script&lang=js&"
export * from "./Viewer.vue?vue&type=script&lang=js&"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=5a8a0bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a0bc4",
  null
  
)

export default component.exports